// eslint-disable-next-line import/prefer-default-export
export const ADD_PHONE_WITH_MASK = 'ADD_PHONE_WITH_MASK';
export const ADD_UID = 'ADD_UID';
export const ADD_SSN4 = 'ADD_SSN4';
export const ADD_AVAILABLE_LIMIT = 'ADD_AVAILABLE_LIMIT';
export const ADD_FIRST_NAME = 'ADD_FIRST_NAME';
export const ADD_PAYFREQUENCY = 'ADD_PAYFREQUENCY';
export const INITIALIZE = 'INITIALIZE';
export const PAY_FREQUENCY_LOOKUP = 'PAY_FREQUENCY_LOOKUP';
export const ADD_VERIFICATION_CODE = 'ADD_VERIFICATION_CODE';
export const ADD_CHECKOUT_UID = 'ADD_CHECKOUT_UID';
export const CONFIRM_PRICE_TAG_DISCLOSURE = 'CONFIRM_PRICE_TAG_DISCLOSURE';
export const CONFIRM_LEASE_AGREEMENT = 'CONFIRM_LEASE_AGREEMENT';
export const CONFIRM_AON_AGREEMENT = 'CONFIRM_AON_AGREEMENT';
export const CONFIRM_KPLUS_ACKNOWLEDGEMENT = 'CONFIRM_KPLUS_ACKNOWLEDGEMENT';
export const CONFIRM_KPLUS_AGREEMENT = 'CONFIRM_KPLUS_AGREEMENT';
export const IS_AON_FLOW = 'IS_AON_FLOW';
export const ADD_USER_ID = 'ADD_USER_ID';
export const CONFIRM_WARRANTY_AGREEMENT = 'CONFIRM_WARRANTY_AGREEMENT';
export const ADD_CHECKOUT_ALL = 'ADD_CHECKOUT_ALL';
export const ADD_PAY_FREQUENCY = 'ADD_PAY_FREQUENCY';
export const ERROR = 'ERROR';
export const CHECKOUT_DECISION = 'CHECKOUT_DECISION';
export const CHANGE_ROUTE = 'CHANGE_ROUTE';
export const SETUP_VWO = 'SETUP_VWO';
export const CHANGE_FEATURE_LINEAR_FLOW = 'CHANGE_FEATURE_LINEAR_FLOW';
export const GET_VWO_DECISION = 'GET_VWO_DECISION';
export const TRACK_VWO_FINAL = 'TRACK_VWO_FINAL';
export const ADD_VWO_DECISION = 'ADD_VWO_DECISION';
export const SETUP_FEATURE_GATES = 'SETUP_FEATURE_GATES';
export const SETUP_TOKEN = 'SETUP_TOKEN';
export const SETUP_SYNCHRONY_FLOW = 'SETUP_SYNCHRONY_FLOW';
export const ADD_SYNCHRONY_PHONE_CHANGED = 'ADD_SYNCHRONY_PHONE_CHANGED';
export const SETUP_SHOPIFY_FLOW = 'SETUP_SHOPIFY_FLOW';
export const SET_DEDGE_TOKEN = 'SET_DEDGE_TOKEN';
export const SET_NEW_USER_FLOW = 'SET_NEW_USER_FLOW';
export const SET_RETURN_USER_FLOW = 'SET_RETURN_USER_FLOW';
export const ADD_NEW_USER_DETAILS = 'ADD_NEW_USER_DETAILS';
export const CHECKOUT_LOOKUP_DATA = 'CHECKOUT_LOOKUP_DATA';
export const ADD_RESOLVE_REDIRECT_URL = 'ADD_RESOLVE_REDIRECT_URL';
export const SET_SHOPIFY_SESSION_ID = 'SET_SHOPIFY_SESSION_ID';
export const SET_SHOPIFY_ORG_ID = 'SET_SHOPIFY_ORG_ID';
export const SET_OFFER_PAGE_FLOW = 'SET_OFFER_PAGE_FLOW';
export const SET_INSTORE_VCC_FLOW = 'SET_INSTORE_VCC_FLOW';
export const ADD_AARONS_REFERRAL = 'ADD_AARONS_REFERRAL';
export const ADD_IN_STORE_CART_ITEM = 'ADD_IN_STORE_CART_ITEM';
export const UPDATE_IN_STORE_CART_ITEM = 'UPDATE_IN_STORE_CART_ITEM';
export const REMOVE_IN_STORE_CART_ITEM = 'REMOVE_IN_STORE_CART_ITEM';
